<svg xmlns="http://www.w3.org/2000/svg" height="95" width="45">
  <g [attr.transform]="transform">
    <path
      d="M33.608 27.712L0 0v94l33.608-27.712c12.127-10 12.127-28.577 0-38.576z"
      [attr.fill]="fill"
    />
    <path
      d="M14.968 39.25l-5.86 6.152c-.351.352-.527.801-.527 1.348 0 .508.176.938.527 1.29l5.86 6.21a1.75 1.75 0 001.289.527c.469 0 .879-.175 1.23-.527.352-.352.528-.8.528-1.348 0-.546-.176-.996-.528-1.347l-2.812-2.93H27.39c.508 0 .937-.176 1.289-.527.351-.391.527-.84.527-1.348 0-.508-.176-.938-.527-1.29-.352-.39-.781-.585-1.29-.585H14.676l2.87-2.93c.352-.351.528-.8.528-1.347 0-.547-.175-.996-.527-1.348a1.753 1.753 0 00-1.29-.527 1.75 1.75 0 00-1.288.527z"
      [attr.fill]="iconFill"
    />
  </g>
</svg>
